var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.breadcrumbs && _vm.breadcrumbs.length
    ? _c("div", { staticClass: "page-header" }, [
        _c(
          "ol",
          { staticClass: "breadcrumb" },
          [
            !_vm.noUseMainPage
              ? _c(
                  "li",
                  {
                    staticClass: "breadcrumb-item",
                    on: {
                      click: function ($event) {
                        return _vm.mixinGoToRouter("home")
                      },
                    },
                  },
                  [_c("a", { attrs: { href: "#" } }, [_vm._v("Главная")])]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.breadcrumbs, function (b) {
              return [
                b.routeName || _vm.customAction
                  ? _c(
                      "li",
                      {
                        staticClass: "breadcrumb-item",
                        on: {
                          click: function ($event) {
                            _vm.customAction
                              ? _vm.customAction(b)
                              : _vm.mixinGoToRouter(b.routeName, b.params)
                          },
                        },
                      },
                      [
                        _c("a", { attrs: { href: "#" } }, [
                          _vm._v(_vm._s(b.title)),
                        ]),
                      ]
                    )
                  : _c("li", { staticClass: "breadcrumb-item active" }, [
                      _vm._v(_vm._s(b.title)),
                    ]),
              ]
            }),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }